(function(){
  function initTasteWheel(root){
    const buttons=Array.from(root.querySelectorAll('[data-cr2-flavor]'));
    const packs=Array.from(root.querySelectorAll('[data-cr2-pack]'));
    const label=root.querySelector('[data-cr2-name]');
    const visual=root.querySelector('.cr2-visual');
    if(!buttons.length||packs.length!==3||!visual)return;
    let sequence=0, scrollTimer=0, imageTimer=0, finishTimer=0;
    const reduceMotion=()=>window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function clearMotion(){
      window.clearTimeout(scrollTimer);
      window.clearTimeout(imageTimer);
      window.clearTimeout(finishTimer);
      visual.classList.remove('cr2-is-rolling');
    }
    function swapPacks(i){
      const targets=[(i+buttons.length-1)%buttons.length,i,(i+1)%buttons.length];
      targets.forEach((choice,position)=>{
        const button=buttons[choice];
        if(!button)return;
        const src=button.dataset.src;
        if(src)packs[position].src=src;
        packs[position].alt='Sachet OstroVit, créatine monohydrate, saveur '+button.dataset.name;
      });
      visual.style.setProperty('--hero-soft',buttons[i].dataset.soft);
    }
    buttons.forEach((button,i)=>button.addEventListener('click',()=>{
      const chosen=button.getAttribute('aria-pressed')==='true';
      const token=++sequence;
      clearMotion();
      if(chosen){
        buttons.forEach(b=>b.setAttribute('aria-pressed','false'));
        if(label)label.textContent='';
        return;
      }
      buttons.forEach((b,j)=>b.setAttribute('aria-pressed',String(j===i)));
      if(label)label.textContent=button.dataset.name;
      const reduced=reduceMotion();
      visual.scrollIntoView({behavior:reduced?'auto':'smooth',block:'center'});
      if(reduced){swapPacks(i);return;}
      // Let the page travel toward the preview before starting the 490 ms revolving movement.
      scrollTimer=window.setTimeout(()=>{
        if(token!==sequence)return;
        visual.classList.remove('cr2-is-rolling');
        void visual.offsetWidth;
        visual.classList.add('cr2-is-rolling');
        imageTimer=window.setTimeout(()=>{if(token===sequence)swapPacks(i);},240);
        finishTimer=window.setTimeout(()=>{
          if(token===sequence)visual.classList.remove('cr2-is-rolling');
        },515);
      },210);
    }));
    buttons.forEach(b=>b.setAttribute('aria-pressed','false'));
    if(label)label.textContent='';
  }
  document.querySelectorAll('[data-crearoma-v2]').forEach(initTasteWheel);
})();

(function(){
  document.querySelectorAll('[data-cr2-gallery]').forEach(root=>{
    const slides=Array.from(root.querySelectorAll('[data-cr2-slide]'));
    const thumbs=Array.from(root.querySelectorAll('[data-cr2-gallery-thumb]'));
    const counter=root.querySelector('[data-cr2-gallery-count]');
    const prev=root.querySelector('[data-cr2-gallery-prev]');
    const next=root.querySelector('[data-cr2-gallery-next]');
    const stage=root.querySelector('.cr2-gallery-stage');
    if(!stage||slides.length<1)return;
    let current=0;
    function showSlide(position){
      current=(position+slides.length)%slides.length;
      slides.forEach((slide,i)=>{slide.hidden=i!==current;});
      thumbs.forEach((thumb,i)=>{thumb.setAttribute('aria-pressed',String(i===current));});
      if(counter)counter.textContent=(current+1)+' / '+slides.length;
    }
    if(prev)prev.addEventListener('click',()=>showSlide(current-1));
    if(next)next.addEventListener('click',()=>showSlide(current+1));
    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>showSlide(i)));
    root.addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft'||event.key==='ArrowRight'){
        if(event.target && /^(INPUT|TEXTAREA|SELECT)$/.test(event.target.tagName))return;
        event.preventDefault();
        showSlide(current+(event.key==='ArrowLeft'?-1:1));
      }
    });
    let startX=null,startY=null;
    stage.addEventListener('touchstart',event=>{
      if(event.touches.length!==1)return;
      startX=event.touches[0].clientX;
      startY=event.touches[0].clientY;
    },{passive:true});
    stage.addEventListener('touchend',event=>{
      if(startX===null||!event.changedTouches.length)return;
      const dx=event.changedTouches[0].clientX-startX;
      const dy=event.changedTouches[0].clientY-startY;
      if(Math.abs(dx)>42&&Math.abs(dx)>Math.abs(dy)*1.3)showSlide(current+(dx<0?1:-1));
      startX=null;startY=null;
    },{passive:true});
    showSlide(0);
  });
})();document.querySelectorAll('[data-cr2-variant-select]').forEach((select)=>{const root=select.closest('.cr2-pdp-details');const label=root&&root.querySelector('[data-cr2-variant-price]');if(!label)return;select.addEventListener('change',()=>{const chosen=select.options[select.selectedIndex];if(chosen&&chosen.dataset.price)label.textContent=chosen.dataset.price;});});
